// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pa-0";